import React, { ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router';
import styles from './styles.module.scss';
import { TIcon } from '../../Icons/Icon.type';
import Icon from '../../Icons/Icon';

type TButtonSize = 'large' | 'normal' | 'small';
type TButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'danger' | 'link';
type TIconPosition = 'left' | 'right';

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: TButtonVariant;
  size?: TButtonSize;
  disabled?: boolean;
  dataTestid?: string;
  icon?: TIcon;
  iconPosition?: TIconPosition;
  to?: string;
}

export const Button = ({
  variant = 'primary',
  size = 'normal',
  disabled,
  dataTestid,
  children,
  icon,
  iconPosition = 'right',
  to,
  onClick,
  ...rest
}: IButtonProps) => {
  const navigate = useNavigate();

  const classes = clsx(styles.button, {
    [styles.primary]: variant === 'primary',
    [styles.secondary]: variant === 'secondary',
    [styles.tertiary]: variant === 'tertiary',
    [styles.danger]: variant === 'danger',
    [styles.link]: variant === 'link',
    [styles.large]: size === 'large',
    [styles.normal]: size === 'normal',
    [styles.small]: size === 'small',
  });

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }

    if (to) {
      navigate(to);
      return;
    }

    onClick?.(e);
  };

  return (
    <button
      className={classes}
      disabled={disabled}
      data-testid={dataTestid}
      onClick={handleClick}
      {...rest}
    >
      {icon && iconPosition === 'left' && (
        <Icon iconType={icon} width={14} height={14} />
      )}
      {children}
      {icon && iconPosition === 'right' && (
        <Icon iconType={icon} width={14} height={14} />
      )}
    </button>
  );
};
